module.exports = __webpack_public_path__ + "fonts/fs_lola-light-webfont.97f51985.ttf";